import { ENV } from './config.js';

/**
 * Navigation Request
 */
export async function FetchGlobalNavigation( token ) {
    //The side nav is the global menu
    const response = await fetch( `https://${ ENV }api.biw.cloud/v2/navigation/menus/GLOBAL/company/person`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    const data = await response.json();
    return data;
}

export async function FetchUserNavigation( token ) {
    //The avatar menu is the user menu
    const response = await fetch( `https://${ ENV }api.biw.cloud/v2/navigation/menus/USER/company/person`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    const data = await response.json();
    return data;
}
export async function FetchGlobalStandaloneNavigation( token ) {
    //The side nav is the global menu - standalone will have full links to biw.cloud addresses
    const response = await fetch( `https://${ ENV }api.biw.cloud/v2/navigation/menus/GLOBAL_STANDALONE/company/person`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    const data = await response.json();
    return data;
}

export async function FetchUserStandaloneNavigation( token ) {
    //The avatar menu is the user menu - standalone will have full links to biw.cloud addresses
    const response = await fetch( `https://${ ENV }api.biw.cloud/v2/navigation/menus/USER_STANDALONE/company/person`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    const data = await response.json();
    return data;
}